export enum ERROR_TYPE {
  SERVER = 'SERVER',
  VALIDATOR = 'VALIDATOR',
  SERVICE = 'SERVICE',
}

export class ErrorResponse {
  code: string;
  statusCode: number;
  type: ERROR_TYPE;
  message: string;
  value?: object = {};
  errors?: { [key: string]: FieldError };

  constructor(error: Partial<ErrorResponse>) {
    this.code = error.code;
    this.statusCode = error.statusCode;
    this.type = error.type;
    this.message = error.message;

    if (error.value) {
      this.value = error.value;
    }
    if (error.errors) {
      this.errors = {};
      Object.keys(error.errors).forEach((field) => {
        this.errors[field] = new FieldError(error.errors[field]);
      });
    }
  }
}

export class FieldError {
  validator: string;
  message: string | undefined;
  value?: object | undefined;

  constructor(fiendError: Partial<FieldError>) {
    this.validator = fiendError.validator;
    this.message = fiendError.message;
    if (fiendError.value) {
      this.value = fiendError.value;
    }
  }
}
